import {
    Box
} from "@mui/material";
import { TextPrimaryBold } from '../typography';

const ListCard = ({ title, image, onClick }: { title: string, image: string, onClick: any }) => {

    return (
        <Box sx={{ display: "flex", alignItems: 'center', gap: 1, py: 1 }} onClick={onClick}>
            <Box
                height={48}
                style={{ width: 48, borderRadius: 2 }}
                component="img"
                src={image}
            />
            <Box style={{ flex: '1 0 auto', marginLeft: 2 }}>
                <TextPrimaryBold text={title} />
            </Box>
        </Box>
    )
}


export default ListCard